import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class, _class2, _temp;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import AddCircle from 'material-ui/svg-icons/content/add-circle';
import { AdTypeIcon, PlanTableHeader, PlanTableRow } from 'components';
import * as styles from './PlanTableHeader.scss';
var PlanTableSection = (_dec = connect(function (state, props) {
  var orgId = state.organization.current.id;
  return {
    user: state.auth.user,
    organization: state.organization.current
  };
}, {}), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  _inherits(PlanTableSection, _Component);

  var _super = _createSuper(PlanTableSection);

  function PlanTableSection(props) {
    var _this;

    _classCallCheck(this, PlanTableSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "categoryPrettyName", function (type) {
      if (type === 'SUBSCRIBED_POSTS') {
        return "Boosts - ".concat(_.startCase(type));
      } else if (type === 'CUSTOM_POSTS') {
        return "Boosts - ".concat(_.startCase(type));
      }

      return _.startCase(type);
    });

    _this.state = {
      showNewAdForm: false,
      newAdFormSubmitEnabled: false
    };
    return _this;
  }

  _createClass(PlanTableSection, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          category = _this$props.category,
          handleNewAdBtnClick = _this$props.handleNewAdBtnClick,
          handleDeletePlanItem = _this$props.handleDeletePlanItem;
      var rows = this.props.hideRows ? [] : category.AdsPlannerAds.sort(function (a, b) {
        if (a.id < b.id) {
          return -1;
        } else if (a.id > b.id) {
          return 1;
        }

        return 0;
      }).map(function (ad, index) {
        // TODO - make this dependent on the month - past, present or future plan?
        var editable = true;
        return /*#__PURE__*/React.createElement(PlanTableRow, {
          key: index,
          ad: ad,
          pastMonth: _this2.props.pastMonth,
          editable: editable,
          handleDeletePlanItem: handleDeletePlanItem,
          formatCurrency: _this2.props.formatCurrency
        });
      });
      var leftContent = this.props.pastMonth || !this.props.user.isLikeableLocal && !this.props.user.isPartner ? null : /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentWrap
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentItem
      }, "Total: ", this.props.formatCurrency(category.budget)), /*#__PURE__*/React.createElement("span", {
        className: styles.leftContentItem
      }, category.AdsPlannerAds.length, ' ', category.type === 'SUBSCRIBED_POSTS' || category.type === 'CUSTOM_POSTS' ? category.AdsPlannerAds.length !== 1 ? ' Posts' : ' Post' : category.AdsPlannerAds.length !== 1 ? ' Ads' : ' Ad', category.type !== 'CUSTOM_POSTS' ? this.props.addBtnMenu : /*#__PURE__*/React.createElement("div", {
        style: {
          display: 'flex',
          justifyContent: 'center',
          width: 48
        }
      }, /*#__PURE__*/React.createElement(AddCircle, {
        style: {
          cursor: 'pointer',
          height: 19,
          width: 19
        },
        onClick: function onClick() {
          _this2.props.handleNewAdBtnClick(category.id);
        }
      }))));
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(PlanTableHeader, {
        icon: /*#__PURE__*/React.createElement(AdTypeIcon, {
          adType: category.type,
          source: "adsPlanner"
        }),
        title: this.categoryPrettyName(category.type),
        leftContent: leftContent
      }), rows);
    }
  }]);

  return PlanTableSection;
}(Component), _defineProperty(_class2, "defaultProps", {
  hideRows: false
}), _temp)) || _class);
export { PlanTableSection as default };